import React from "react";

export default function ProductCatalogSortableHeader({
  columnKey,
  label,
  sortConfig,
  onSort,
  widthClass = "",
  onDropColumn,
  filterId,
  children,
}) {
  const canReorder = Boolean(onDropColumn);

  return (
    <th
      scope="col"
      aria-sort={
        sortConfig.key === columnKey
          ? sortConfig.direction === "asc"
            ? "ascending"
            : "descending"
          : "none"
      }
      onDragOver={canReorder ? (event) => event.preventDefault() : undefined}
      onDrop={
        canReorder ? (event) => onDropColumn(event, columnKey) : undefined
      }
      className={`${widthClass} border-b border-gray-200 px-2 py-2 text-left align-top`}
    >
      <div className="flex items-center gap-1">
        {canReorder && (
          <span
            draggable
            onDragStart={(event) => {
              event.dataTransfer.effectAllowed = "move";
              event.dataTransfer.setData("text/plain", columnKey);
            }}
            title={`Drag to reorder ${label}`}
            aria-label={`Drag to reorder ${label}`}
            className="cursor-grab select-none text-gray-400 active:cursor-grabbing"
          >
            ⠿
          </span>
        )}
        <button
          type="button"
          onClick={() => onSort(columnKey)}
          className="text-left font-semibold text-gray-800 hover:text-blue-800"
        >
          {label}
          {sortConfig.key === columnKey && (
            <span aria-hidden="true" className="ml-1">
              {sortConfig.direction === "asc" ? "↑" : "↓"}
            </span>
          )}
        </button>
      </div>
      {filterId && (
        <label className="sr-only" htmlFor={filterId}>
          Filter by {label}
        </label>
      )}
      {children}
    </th>
  );
}
